import { useInView } from '@/hooks'

export const WelcomeSection = () => {
  const { ref, inView } = useInView<HTMLDivElement>()

  return (
    <section className="bg-crimson-50 py-16 lg:py-20 border-b border-crimson-100">
      <div ref={ref} className="max-w-[900px] mx-auto px-6 lg:px-12">
        <div className={`space-y-6 ${inView ? 'animate-fade-in-up' : 'opacity-0'}`}>
          <div>
            <h2
              className="font-display font-bold text-base-900 leading-tight mb-3"
              style={{ fontSize: 'clamp(1.85rem, 4vw, 2.75rem)' }}
            >
              Welcome to <em className="text-crimson-600 not-italic italic">H.E.R Birth Keeper</em>
            </h2>
          </div>

          <div className="w-12 h-[3px] rounded-full bg-gradient-to-r from-crimson-600 to-gold-500" />

          <p className="text-[12px] text-base-500 uppercase tracking-[0.16em] font-semibold">
            Your Antenatal &amp; Postpartum Birth Keeper Across Essex, North Kent and East London
          </p>

          <div className="space-y-4 text-[15px] text-base-600 leading-[1.9]">
            <p>
              A space created to gently support you through one of the most powerful and
              transformative journeys of your life. Whether you are preparing for birth, processing
              your experience, or navigating the early days of parenthood, you deserve to feel
              informed, held, and deeply supported. Here, you are offered a safe and nurturing
              environment where your voice matters, your choices are respected, and your journey is
              honoured.
            </p>
            <p>
              Through personalised, holistic care, H.E.R Birth Keeper supports you from pregnancy
              through to postpartum, helping you feel confident, empowered, and connected to
              yourself every step of the way. From antenatal preparation to birth healing and
              postpartum recovery, this is a space where you can slow down, reconnect, and receive
              the care you truly deserve as you step into parenthood with clarity and support.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
